import axiosLogin from "global/helpers/axiosLogin";
import { LOGIN_ERROR, LOGIN_LOADING, LOGIN_SUCCESS } from "../../ActionTypes";

export const loginSocial =
  (id, red, tokenRedSocial, origin, nextStep) => (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .post("/shared/AuthSocial", {
          id,
          red,
          tokenRedSocial,
          origin,
        })
        .then((res) => {
          /*         sessionStorage.token = res.data.token;
        let data = {
          ...res.data,
          origen: "vinculaSocialOk",
        }; */
          if (res.data !== null && res.data !== undefined) {
            nextStep(true, res.data, id, red, tokenRedSocial);
          }
          /*           dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data,
          }); */
        })
        .catch((err) => {
          /*         let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "redSocial",
        }; */
          if (err.response !== null && err.response !== undefined) {
            nextStep(false, err.response);
          }
          /*      dispatch({
          type: LOGIN_ERROR,
          payload: error,
        }); */
        });
    });
  };
// export const loginSocial = (id, red, tokenRedSocial) => (dispatch) => {
//   dispatch({
//     type: LOGIN_LOADING,
//   });

//   axiosInstance().then(respuesta => {
//   respuesta
//   .post("/auth/redsocial", {
//     id,
//     red,
//     tokenRedSocial,
//   })
//   .then((res) => {
//     sessionStorage.token = res.data.token;
//     let data = {
//       ...res.data,
//       origen: "vinculaSocialOk",
//     };
//     dispatch({
//       type: LOGIN_SUCCESS,
//       payload: data,
//     });
//   })
//   .catch((err) => {
//     let error = {
//       detail: err.response
//         ? err.response.data
//         : "Error al contactar el server.",
//       origen: "redSocial",
//     };

//     dispatch({
//       type: LOGIN_ERROR,
//       payload: error,
//     });
//   });
//  } )
// };

/* export const loginSocialBackend = (id, tokenRedSocial) => (dispatch) => {
  dispatch({
    type: LOGIN_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/auth/apple", {
        id,
        tokenRedSocial,
      })
      .then((res) => {
        sessionStorage.token = res.data.token;
        let data = {
          ...res.data,
          origen: "vinculaSocialOk",
        };
        dispatch({
          type: LOGIN_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "redSocial",
        };

        dispatch({
          type: LOGIN_ERROR,
          payload: error,
        });
      });
  });
}; */
